import Types from "./Types";

export const getAllTeachersRequest = (body) => ({
  type: Types.GET_SUPERADMIN_TEACHERS_REQUEST,
  payload: body,
});

export const getAllTeachersSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_TEACHERS_SUCCESS,
  payload: data,
});

export const getAllTeachersFail = () => ({
  type: Types.GET_SUPERADMIN_TEACHERS_FAIL,
});

export const editTeacherRequest = (formData, action) => ({
  type: Types.EDIT_SUPERADMIN_TEACHER_REQUEST,
  payload: formData,
  action: action,
});

export const editTeacherSuccess = (data) => ({
  type: Types.EDIT_SUPERADMIN_TEACHER_SUCCESS,
  payload: data,
});

export const editTeacherFail = () => ({
  type: Types.EDIT_SUPERADMIN_TEACHER_FAIL,
});

//LOADING
export const addTeacherLoading = (isLoading) => ({
  type: Types.ADD_SUPERADMIN_TEACHERS_LOADING,
  payload: isLoading,
});

// Create Teacher
export const createTeacherRequest = (formData, action) => ({
  type: Types.CREATE_SUPERADMIN_TEACHER_REQUEST,
  payload: formData,
  action: action,
});

export const createTeacherSuccess = ({ data }) => ({
  type: Types.CREATE_SUPERADMIN_TEACHER_SUCCESS,
  payload: {
    data,
  },
});

export const createTeacherFail = () => ({
  type: Types.CREATE_SUPERADMIN_TEACHER_FAIL,
});

export const deleteTeacherRequest = (id) => ({
  type: Types.DELETE_SUPERADMIN_TEACHER_REQUEST,
  payload: id,
});

export const deleteTeacherSuccess = (id) => ({
  type: Types.DELETE_SUPERADMIN_TEACHER_SUCCESS,
  payload: id,
});

export const deleteTeacherFail = () => ({
  type: Types.DELETE_SUPERADMIN_TEACHER_FAIL,
});

export const addTeacherAdminRequest = (formData, action) => ({
  type: Types.ADD_TEACHER_ADMIN_REQUEST,
  payload: formData,
  action: action,
});

export const addTeacherAdminSuccess = (data) => ({
  type: Types.ADD_TEACHER_ADMIN_SUCCESS,
  payload: data,
});

export const addTeacherAdminFail = () => ({
  type: Types.ADD_TEACHER_ADMIN_FAIL,
});
